module.exports = __webpack_public_path__ + "img/return_refund.a3b8fe09.png";